import { LOGIN_COMPONENTS } from "@constants/verticalConstants";
import { useLoginFeatures } from "@hooks/store";
import AdmissionNoLogin from "./AdmissionNoLogin";
import MobileNoLogin from "./MobileNoLogin";

const LoginPage = () => {
  const loginFeatures = useLoginFeatures();

  if (loginFeatures.component === LOGIN_COMPONENTS.LOGIN_WITH_ADMISSION_NO) {
    return <AdmissionNoLogin />;
  }

  return <MobileNoLogin />;
};

export default LoginPage;
